import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { PersonContext } from '../context/PersonContext';
import { DialogContext } from '../context/DialogContext';
import restapi from '../utils/restapi';
import PersonLogin from '../pages/person/login';
import TestingTeacherDocumentJoin from '../pages/testing_teacher_document/join';
import './intro.css';

const Intro = () => {
  const { person, logout } = useContext(PersonContext);
  const { openDialog, closeDialog } = useContext(DialogContext);
  const navigate = useNavigate();

  const [testingTeacherDocumentObj, setTestingTeacherDocumentObj] = useState(null);

  // 환경변수에서 버전 가져오기
  const version = process.env.REACT_APP_VERSION || '1.0.0';

  const openLoginDialog = () => {
    const customStyles = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0',
      },
    };

    openDialog(<PersonLogin />, customStyles);
  };

  const handleBackLogin = () => {
    navigate('/backlogin');
  };

  // teacher
  const handleGetData = async (params) => {
    console.log("handleGetData requestParams:", params);
    
    // person이 준비되지 않았으면 빈 결과 반환
    if (!person || !person.person_id) {
      console.log('person 데이터가 없습니다.');
      return { lists: [], total: 0, totalPages: 0 };
    }

    const requestParams = {
      ...params,
      person_id: person.person_id
    };
    console.log("handleGetData with person_id requestParams:", requestParams);
    
    try {
      const results = await restapi.get_testing_teacher_documents(requestParams);
      console.log("handleGetData results:", results);
      return results;
    } catch (error) {
      console.error("Error fetching data:", error);
      return { lists: [], total: 0, totalPages: 0 };
    }
  };

  const handleLogout = () => {
    // 로그아웃 처리 로직을 여기에 추가합니다.
    console.log('로그아웃 처리');
    // 예: 세션 종료, 토큰 삭제 등
    logout();
  };

  useEffect(() => {
    if (person?.person_id) {
      handleGetData().then((results) => {
        // results.lists중에서 status가 1이하이면 첫번째것만 설정
        console.log(results);

        for (const item of results.lists) {
          console.log(item);
          //if (item.status <= 1) {
          setTestingTeacherDocumentObj(item);
          break;
          //}
        }

        if (results.lists.length <= 0) {
          setTestingTeacherDocumentObj(null);
        } else if(!testingTeacherDocumentObj) {
          setTestingTeacherDocumentObj(results.lists[0] || null);
        }
      }).catch((error) => {
        console.error("Error fetching testing teacher documents:", error);
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [person?.person_id]);

  useEffect(() => {
    if (testingTeacherDocumentObj && testingTeacherDocumentObj.status <= 1) {
      handleEditClick(testingTeacherDocumentObj);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [testingTeacherDocumentObj]);

  const handleEditClick = (item) => {
    // 작성하기 버튼 클릭 시 처리 로직을 여기에 추가합니다.
    console.log('작성하기 버튼 클릭:', item);
    // openDialog를 사용하여 작성 페이지를 열기
    const customStyles = {
      overlay: {
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // 배경 색상
      },
      content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        padding: '0',
      },
    };

    openDialog(<TestingTeacherDocumentJoin testingTeacherDocumentObj={item} onSave={handleTestingTeacherDocumentSave} onClose={closeDialog} />, customStyles);
  };

  const handleTestingTeacherDocumentSave = async (json) => {
    console.log("TestingTeacherDocument saved:", json);
    handleGetData().then((results) => {
      // results.lists중에서 status가 1이하이면 첫번째것만 설정
      const filtered = results.lists.filter(item => item.status <= 1);
      if (filtered.length > 0) {
        setTestingTeacherDocumentObj(filtered[0]);
      } else {
        setTestingTeacherDocumentObj(null);
      }

      console.log(testingTeacherDocumentObj);
    }).catch((error) => {
      console.error("Error fetching testing teacher documents:", error);
    });

    closeDialog(); // 다이얼로그 닫기
  }

  return (
    <div id="intro">
      <div className="head">
        <h1>한국실용글쓰기검정 v{version}</h1>
        <h2 onDoubleClick={handleBackLogin}>감독관</h2>
      </div>
      {person && person.person_id ? (
        <div className="body">
          { testingTeacherDocumentObj && testingTeacherDocumentObj?.status > 1 ? (
            <div>
              <p>작성하신 서명이 정상적으로 제출되었습니다.</p>
              <p>더이상 작성하실 서명이 없습니다.</p>
              <p>감사합니다.</p>
              <button
                onClick={() => handleLogout()}
              >
                로그아웃
              </button>
            </div>
          ) : (
              <div>
                <p>{ testingTeacherDocumentObj?.testingTeacherObj?.testingScheduleObj?.testingObj?.title } 감독관 서류를 작성해 주세요.</p>
                <button 
                  onClick={() => handleEditClick(testingTeacherDocumentObj)}
              >
                작성하기
                </button>
                <button 
                  onClick={() => handleLogout()}
              >
                로그아웃
                </button>
              </div>              
          )}
        </div>
      ) : (
        <div className="body">
          <p>감독관으로 등록된 사용자만 접근할 수 있습니다.</p>
          <p>협회나 지역본부에 감독관 등록여부를 확인 바랍니다.</p>
          <div>
            <button onClick={openLoginDialog}>로그인하기</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Intro;